import React, { FC } from 'react';

import styled, { keyframes } from 'styled-components';

// This is the path that both the ball and the line will take.
// eslint-disable-next-line max-len
const animationPath =
  'M-30.5508 140.928C30.5507 79.8262 117.768 8.37686 121.217 126.638C140.435 48.7827 190.696 22.174 216.812 5.91309';
const aniTime = '2s';

const Move = keyframes`
  0% {
    offset-distance: 0%;
    stroke-dashoffset:382;
  }
  20% {
    offset-distance: 100%;
    stroke-dashoffset: 0;
  }
  
  100%{
    offset-distance: 100%;
    stroke-dashoffset: 0;
  }
`;

const Squiggle = styled.path`
  stroke-dasharray: 382;
  stroke-dashoffset: 382;
  animation: ${Move} ${aniTime} ease-out infinite;
`;

const Ball = styled.circle`
  offset-path: path('${animationPath}');
  animation: ${Move} ${aniTime} ease-out infinite;
`;

const Item = styled.div`
  width: 250px;
  height: 250px;
  align-items: center;
  justify-content: center;
  display: flex;
`;

const InnerContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Container = styled.div`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--color-extra-white);
`;

interface Props {
  className?: string;
}

export const Loader: FC<Props> = ({ className }) => (
  <Container>
    <InnerContainer>
      <Item>
        <svg className={className} viewBox="0 0 223 136" fill="none">
          <path
            fill="#1CCBD7"
            // eslint-disable-next-line max-len
            d="M181.551 79.0445L134.864 32.304C132.529 29.9664 128.744 29.9664 126.413 32.304L79.7214 79.0445C78.6156 80.1516 77.9899 81.6424 77.9723 83.2082C77.9723 83.4464 77.7124 106.995 77.9679 129.649C77.9591 129.768 77.9591 129.891 77.9591 130.015C77.9591 133.318 80.6334 136 83.9377 136H177.326C180.626 136 183.305 133.323 183.305 130.015V83.2743C183.305 81.6865 182.675 80.1648 181.556 79.0445"
          />
          <Squiggle d={animationPath} stroke="#DDF33F" strokeWidth="11.8261" strokeLinejoin="bevel" />
          <Ball r="6" fill="#1CCBD7" />
        </svg>
      </Item>
    </InnerContainer>
  </Container>
);

export default Loader;
